import {Component, computed, EventEmitter, inject, Input, Output, Signal} from '@angular/core';
import {DialogModule} from "@syncfusion/ej2-angular-popups";
import {CustomerService} from "../../../shared/services/customer.service";
import {DialogService} from "../../../shared/services/dialog.service";
import {QRCodeComponent} from "angularx-qrcode";
import {HeadlineComponent} from "../../../shared/elements/headline/headline.component";
import {TranslatePipe} from '../../../shared/pipes/translate.pipe';
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";

@Component({
  selector: 'app-app-download-dialog',
  imports: [
    DialogModule,
    QRCodeComponent,
    HeadlineComponent,
    TranslatePipe,
    TooltipComponent
],
  templateUrl: './app-download-dialog.component.html',
  styleUrl: './app-download-dialog.component.scss'
})
export class AppDownloadDialogComponent {
  public dialogService: DialogService = inject(DialogService);
  private customerService: CustomerService = inject(CustomerService);

  @Input() public visible: boolean = false;
  @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public downloadUrl: Signal<string | null> = computed(() => {
    const customerKey = this.customerService.customerKey();
    if (!customerKey) return 'https://dl.humanstars.app/downloads';
    return `https://dl.humanstars.app/downloads/${customerKey}`;
  });

  public close(): void {
    this.visibleChange.emit(false);
  }
}
